import { applyMiddleware, compose, Store, createStore } from "redux";
import thunkMiddleware from "redux-thunk";
import { Provider } from "react-redux";

import {
    IInitialSettings,
    IStore,
    FormState,
    IGridInitialSettings,
    IStoreCustomFormGrid,
} from "./DataTypes/storeTypes";
import { CustomFormConnected } from "./React/CustomForm";
import { gridRootReducer, rootReducer } from "./Reducers/root";
import { createChangeTrackerMiddleware } from "common.ui/FormChangeTracker/formChangeTrackerMiddleware";
import { Actions } from "./Actions/actionTypes";
import Auth from "./React/Auth";
import { getDefaultState, getGridDefaultState } from "./storeManager";
import React, { Component } from "react";
import { createRoot } from "react-dom/client";
import { CustomFormGrid } from "./React/CustomFormGrid";
import { GlobalThemeProvider } from "@powerdiary/components-library/lib";

// NOTE: Do NOT remove as this export the Mode to be used in the View with the initial settings
export { Mode } from "common.ui/CustomForms/Editor/DataTypes/dataTypes";

export class CustomFormProvider extends Component<IInitialSettings> {
    store: Store<IStore>;

    constructor(props: IInitialSettings) {
        super(props);

        const initialState: IStore = getDefaultState(props);

        const middlewares: any[] = [thunkMiddleware, this.initializeFormChangeMiddleware()];

        const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] || compose;
        this.store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));
    }

    initializeFormChangeMiddleware() {
        return createChangeTrackerMiddleware({
            actionTypes: [Actions.SetFormState],
            stateSlicer: (state) => false,
            handler: (action, result, store, stateSlicer, tracker) => {
                switch (action.type) {
                    case Actions.SetFormState:
                        const state = action.parameter;
                        switch (state) {
                            case FormState.Saved:
                                tracker.setInitialState(false);
                                break;
                            case FormState.Dirty:
                                tracker.setInitialState(true);
                                break;
                        }
                        break;
                }
            },
        });
    }

    render() {
        return (
            <Provider store={this.store}>
                {this.props.authenticationSuccessful === false && this.props.authenticationRequired === true ? (
                    <Auth {...this.props} />
                ) : (
                    <CustomFormConnected />
                )}
            </Provider>
        );
    }
}

export class CustomFormGridProvider extends Component<IGridInitialSettings> {
    store: Store<IStoreCustomFormGrid>;

    constructor(props: IGridInitialSettings) {
        super(props);

        const data: IStoreCustomFormGrid = getGridDefaultState(props);
        const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] || compose;
        this.store = createStore(gridRootReducer, data, composeEnhancers(applyMiddleware(thunkMiddleware)));
    }

    render() {
        return (
            <Provider store={this.store}>
                <CustomFormGrid />
            </Provider>
        );
    }
}

export const renderFormView = (params: IInitialSettings, mountPoint: string) => {
    const container = document.getElementById(mountPoint);
    const root = createRoot(container);
    root.render(
        <GlobalThemeProvider>
            <CustomFormProvider {...params} />
        </GlobalThemeProvider>
    );
};

export const renderFormList = (params: IGridInitialSettings, mountPoint: string) => {
    const container = document.getElementById(mountPoint);
    const root = createRoot(container);
    root.render(
        <GlobalThemeProvider>
            <CustomFormGridProvider {...params} />
        </GlobalThemeProvider>
    );
};
